const Constants = {
  httpAuthToken: "bearer obfMAswessMOadBilayIivzirAppppEmaiL",
  locale_en_OM: "en-OM",
  locale_ar_OM: "ar-OM",
};
export default Constants;
